import { useLocation } from 'react-router-dom';
import { getCurrentModule, type ModuleType } from '@/lib/moduleContext';

/** React hook that returns the active module derived from the current route. */
export function useCurrentModule(): ModuleType {
  const location = useLocation();
  return getCurrentModule(location.pathname);
}
